import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '../../guards/auth.guard';
import { ClientListComponent } from './clients-list/clients-list.component';
import { ClientComponent } from './clients-add-update/clients-add-update.component';

const routesClients: Routes = [
    { path: 'clients', component: ClientComponent, canActivate: [AuthGuard] },
    { path: 'clients-list', component: ClientListComponent, canActivate: [AuthGuard] }
];

@NgModule({
    imports: [RouterModule.forChild(routesClients)],
    exports: [RouterModule],
})

export class ClientsRoutingModule { }